import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

function ProductStatusHeader({ search, counts, onSearchChange }) {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h4" data-cy="products-on-back-order-title">
        Products On Back Order
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Search by part number. Both sections update together.
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1.5 }}>
        <Chip label={`Back Orders: ${counts.backOrders ?? 0}`} color="warning" variant="outlined" />
        <Chip
          label={`Discontinued: ${counts.discontinued ?? 0}`}
          color="default"
          variant="outlined"
        />
        <Chip label={`Total: ${counts.total ?? 0}`} color="primary" variant="outlined" />
      </Box>

      <TextField
        fullWidth
        size="small"
        label="Search Part No"
        value={search}
        onChange={onSearchChange}
        placeholder="Type part number..."
        inputProps={{ 'data-cy': 'products-on-back-order-search' }}
      />
    </Box>
  );
}

ProductStatusHeader.propTypes = {
  search: PropTypes.string.isRequired,
  counts: PropTypes.shape({
    backOrders: PropTypes.number,
    discontinued: PropTypes.number,
    total: PropTypes.number,
  }).isRequired,
  onSearchChange: PropTypes.func.isRequired,
};

export default React.memo(ProductStatusHeader);
